import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import { Button, ButtonType } from '../Button';
import { Modal } from '../Modal';

// Angular source: apps/angular/src/js/ng/sitter/registration/photo-guide-modal.*
// The sitter-side guide shows during the sitter photo upload step.
// Parents posting a job also need a photo-tips prompt; they see the
// `parent` variant, which swaps the audience-specific copy.
interface Props {
  isOpen: boolean;
  onClose: () => void;
  variant?: 'sitter' | 'parent';
}

export const PhotoGuideModal = ({
  isOpen,
  onClose,
  variant = 'sitter',
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const tipKeys =
    variant === 'parent'
      ? [
          'components.modals.photoGuide.tips.clearPhoto',
          'components.modals.photoGuide.tips.aloneInFrame',
          'components.modals.photoGuide.tips.noObstructionsParent',
          'components.modals.photoGuide.tips.smileParent',
        ]
      : [
          'components.modals.photoGuide.tips.clearPhoto',
          'components.modals.photoGuide.tips.aloneInFrame',
          'components.modals.photoGuide.tips.noObstructionsSitter',
          'components.modals.photoGuide.tips.smileSitter',
        ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-full max-w-md'>
      <Button
        aria-label={t('common.close')}
        onClick={onClose}
        className='absolute right-2 top-2 text-gray-400 hover:text-gray-500 transition-colors'
      >
        <FontAwesomeIcon icon={faXmark} className='w-5 h-5' />
      </Button>
      <h3 className='font-semibold mb-3'>{t('components.modals.photoGuide.title')}</h3>
      <ul className='list-disc pl-5 space-y-2 text-sm mb-4'>
        {tipKeys.map((key) => (
          <li key={key}>{t(key)}</li>
        ))}
      </ul>
      <div className='text-right'>
        <Button buttonType={ButtonType.primary} onClick={onClose}>
          {t('components.modals.photoGuide.gotIt')}
        </Button>
      </div>
    </Modal>
  );
};
